export { ConsultantSlimBanner } from "./ConsultantSlimBanner";
export type {
	ConsultantSlimBannerProps,
	ConsultantSlimBannerCta,
	HeadingTag
} from "./ConsultantSlimBanner";
